import { Box } from "@chakra-ui/react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import TemplateLayout from "src/components/layout";
import ChargeStationsComponent from "src/template/network/charge-stations";

const ChargeStationsPage = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Charge Stations | Documents</title>
        </Helmet>
        <TemplateLayout>
          <Box minHeight={"calc(100vh - 86px)"}>
            <Box
              minHeight={"calc(100vh - 86px)"}
              display={"flex"}
              justifyContent={"center"}
            >
              <ChargeStationsComponent />
            </Box>
          </Box>
        </TemplateLayout>
      </HelmetProvider>
    </>
  );
};

export default ChargeStationsPage;
